import typeCheck from 'common/util/typeCheck';

export default function setMapCenter({ state }, { lat, lng, mapArea }) {
  typeCheck('lat::Number', lat);
  typeCheck('lng::Number', lng);

  state.set(['listingsMapView', 'showResultsMatched'], false);
  state.set(['listingsMapView', 'showRedoSearch'], true);
  state.set(['listingsMapView', 'mapChanged'], true);
  state.set(['listingsMapView', 'mapArea'], mapArea);
  state.set(['listingsMapView', 'mapCenter'], { lat, lng });
}
